import { Accordion, AccordionSummary, styled, Box } from '@mui/material'

export const ThinScrollContainer = styled(Box)(({ theme }) => ({
  maxHeight: 250,
  overflowY: 'auto',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),

  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
}))

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: 'none',
  '&:before': { display: 'none' },
  backgroundColor: 'transparent',
  marginBottom: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  '&.MuiAccordion-root.is-selected': {
    borderLeft: `3px solid ${theme.palette.secondary.main}`,
  },
  borderLeft: '3px solid transparent',
}))

export const StyledAccordionSummary = styled(AccordionSummary, {
  shouldForwardProp: prop => prop !== 'isSelected' && prop !== 'isExpanded',
})(({ theme, isSelected, isExpanded }) => ({
  padding: 0,
  minHeight: 56,
  borderRadius: theme.shape.borderRadius,
  transition: 'background-color 0.2s',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  backgroundColor: isSelected ? theme.palette.action.selected : 'transparent',

  '& .MuiAccordionSummary-content': {
    margin: '12px 0',
    alignItems: 'center',
    paddingRight: theme.spacing(1.5),
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    color: isExpanded ? theme.palette.secondary.main : theme.palette.text.secondary,
  },
}))
